export const SignalStrengthPageData = {
    "title":"Local Broadcast Signal Strenght Detector", 
        "pageContent": {
            "heading":{
                "content":"Local Broadcast Strength Detector"
            }, 
            "subheaderText": [
                {
                    "content": "Use this tool to see over-the-air signal strength for an indoor HD antenna. Signal strength calculations assume an indoor antenna 9 feet above ground level. Actual reception quality may vary significantly for viewers using an outdoor antenna"
                }, 
                {
                    "content": "Signal strength availability displayed here is based on data made available by the FCC. Signal strength and availability not guaranteed."
                }, 
                {
                    "content": "Actual signal strength may vary by location and is based on a variety of factors, including but not limited to, building construction, neighboring buildings and trees, topography, weather and specific reception hardware."
                },
            ], 
            "searchBoxHeader": {
                "content" : "Search Location"
            }, 
            "searchBoxPlaceHolder": {
                "content": "Address, City, Zip..."
            }, 
            "strengthLegendHeader": {
                "content": "Legend: "
            }, 
            "strengthLegendValues" : [
                {
                    "content": "Strong"
                }, 
                {
                    "content": "Moderate"
                }, 
                {
                    "content": "Weak"
                },
            ], 
            "tipsHeader": {
                "content": "Tips"
            }, 
            "tipsList": [
                {
                    "content": "If searching on city, include state"
                }, 
                {
                    "content": "If searching on street address, include city and state"
                }, 
                {
                    "content": "Exclude PO Box, Mailbox, APT # in address search parameters"
                }, 
                {
                    "content": "Avoid using special characters, such as @, #, $, %, *, etc."
                },
            ], 
            "searchResultHeader":{
                "content": "Local Channel Connections"
            },
            "resultQuantityLabel": {
                "content": "Results"
            }, 
            "searchErrorMessage": {
                "content": "Please refine search criteria."
            }, 

        }
}